import { createContext, useContext } from 'react';

import { useCheckboxGroupState } from './useCheckboxGroupState';

export type CheckboxGroupState = ReturnType<typeof useCheckboxGroupState>;
export const CheckboxGroupContext = createContext<CheckboxGroupState | null>(
  null
);
export const useCheckboxGroupContext = () => useContext(CheckboxGroupContext);
